/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Container } from './styles'

export default function SelectAutocomplete(props) {
  const {
    options,
    loading,
    noOptionsText,
    onChange,
    onSelect,
    name,
    label,
    selected,
    renderOption,
  } = props

  const handleChange = (_, value) => {
    onSelect(value)
  }

  const onChangeInput = (evt) => {
    onChange(evt)
  }

  const renderInput = (params) => (
    <TextField
      label={label}
      name={name}
      {...params}
      size="small"
      variant="outlined"
      onChange={onChangeInput}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            { loading ? <CircularProgress size={20} /> : null }
            { params.InputProps.endAdornment }
          </>
        ),
      }}
    />
  )

  return (
    <Container>
      <Autocomplete
        value={selected}
        filterOptions={(option) => option}
        getOptionSelected={(option) => option}
        getOptionLabel={(option) => option?.name || ''}
        options={options}
        loading={loading}
        renderInput={(params) => renderInput(params)}
        onChange={handleChange}
        noOptionsText={noOptionsText}
        renderOption={renderOption}
      />
    </Container>
  )
}

SelectAutocomplete.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  noOptionsText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  selected: PropTypes.objectOf(PropTypes.any),
  renderOption: PropTypes.func,
}

SelectAutocomplete.defaultProps = {
  options: [],
  loading: false,
  noOptionsText: 'Digite para selecionar',
  label: '',
  selected: {},
  renderOption: null,
}
